export default {
  stepsContainer: {
    width: '100%',
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-around'
  }
}
